import React from "react";
import { useIntl } from "react-intl";
import { RotateCw } from "react-feather";
import "./styles.scss";

const NewKmlButton = ({ textId, onClick, isLoading, ...props }) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <button className={`button ${isLoading ? " is-loading" : ""}`} 
        onClick={onClick}
      >
        < RotateCw size="12" /> {formatMessage({ id: textId })}
      </button>
    </>
  );
};

export default NewKmlButton;
